// Below algorism is from https://www.movable-type.co.uk/scripts/latlong.html
// Return distance in kilometre
export const distanceOfCoords = (coordA) => (coordB) => {
  const { lat: lat1, lon: lon1 } = coordA;
  const { lat: lat2, lon: lon2 } = coordB;
  const Phi1 = (lat1 * Math.PI) / 180;
  const Phi2 = (lat2 * Math.PI) / 180;
  const DeltaLambda = ((lon2 - lon1) * Math.PI) / 180;
  const R = 6371;
  const d =
    Math.acos(
      Math.sin(Phi1) * Math.sin(Phi2) +
        Math.cos(Phi1) * Math.cos(Phi2) * Math.cos(DeltaLambda)
    ) * R;
  return Math.round(d * 100) / 100;
};

function checkCoordinate(crd) {
  const geoDestinations = window.ecom.craftConfig?.geoDestinations || [];
  const distanceFromCurrentLocation = distanceOfCoords({
    lat: crd.latitude,
    lon: crd.longitude,
  });
  geoDestinations.every((destination) => {
    const distance = distanceFromCurrentLocation({
      lat: destination.latitude,
      lon: destination.longitude,
    });
    if (distance <= destination.distance) {
      const modalTitle = document.querySelector('#geo-location-modal h5');
      modalTitle.innerHTML = destination.modalTitle || '';

      const modalContent = document.querySelector(
        '#geo-location-modal .modal-body'
      );
      modalContent.innerHTML = destination.message;

      const confirmBtn = document.querySelector(
        '#geo-location-modal .modal-confirm-btn'
      );
      confirmBtn.innerHTML = destination.linkText || 'Confirm';
      confirmBtn.setAttribute('href', destination.link);

      const modal = new window.BsModal(
        document.getElementById('geo-location-modal')
      );
      modal.show();
      return false;
    }
    return true;
  });
}

const TIME_OF_ONE_DAY = 1000 * 3600 * 24;
const EXPIRE_TIME = 30 * TIME_OF_ONE_DAY;
export function isExpired(obj) {
  if (obj?.createDate) {
    const createDate = new Date(obj.createDate);
    const currentDate = new Date();
    const diffInTime = currentDate.getTime() - createDate.getTime();
    if (diffInTime > EXPIRE_TIME) {
      return true;
    }
    return false;
  }
  return true;
}

function getLocationAndCheck() {
  navigator?.geolocation.getCurrentPosition((pos) => {
    const crd = pos.coords;
    window.localStorage.setItem(
      'USER_COORDINATE',
      JSON.stringify({
        latitude: crd.latitude,
        longitude: crd.longitude,
        createDate: new Date(),
      })
    );
    checkCoordinate(crd);
  });
}

function onLoaded() {
  const params = new URLSearchParams(document.location.search);
  const fromBU = params.get('from') === 'bu';
  if (fromBU || !window.ecom.craftConfig?.geoDestinations) {
    return;
  }
  const coordinate = window.localStorage.getItem('USER_COORDINATE');
  if (coordinate) {
    const obj = JSON.parse(coordinate);
    if (isExpired(obj)) {
      getLocationAndCheck();
    } else {
      checkCoordinate(obj);
    }
  } else {
    getLocationAndCheck();
  }
}

document.addEventListener('DOMContentLoaded', onLoaded);
